export enum CacheControlAgeTime {
  FIVE_MINUTES = 300,
  HOUR = 3600,
  MONTH = 2592000,
  QUARTER = 7776000,
  YEAR = 31536000,
}
